import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField } from "helpers/row-logic-helper";

import { shouldShowField } from "../loanDetailEditUtil";

import {
  shouldShowTransferFee,
  shouldShowConditionsToTransfer
} from "./section-loan-assumptions-row-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  assumable: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Assumable",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => {
          const assumable = data.details.assumable;

          return assumable ? "This loan is assumable." : "This loan is not assumable.";
        },
        Cell: tableSideColumnMapper
      }
    ]
  },
  transferFee: {
    isVisible: data => shouldShowTransferFee(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Transfer Fee",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: data => defaultField(data, "details.transferFee"),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },
  conditionsToTransfer: {
    isVisible: data => shouldShowConditionsToTransfer(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Conditions to Transfer",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT_SUBTEXT,
        map: data => defaultField(data, "details.conditionsToTransfer"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
